export const handleChangeDataCourierOrderDetails = (name, value) => ({
    type: 'CHANGE_DATA_COURIER_ORDER_DETAILS', name, value
});